import { useQuery } from '@based/sdk'
import { ActiveFilterChip } from '@app/components/blocks/searchGrid/SearchGrid'
import { useTranslations } from '@i18n/useLanguage'
import { InitiativeFilter } from 'functions/app/initiative/list/filters'
import { ListPhaseModel } from 'functions/app/dashboard/supporting-entities/phase/list'
import { ListDevelopmentFormModel } from 'functions/app/dashboard/supporting-entities/development-form/list'
import { useMemo } from 'react'

export const useInitiativeFilterChips = (
  filters: InitiativeFilter,
  setFilters: (filters: InitiativeFilter) => void,
): ActiveFilterChip[] => {
  const { data: phases }: { data?: ListPhaseModel[] } = useQuery('list-phase')
  const { data: developmentForms }: { data?: ListDevelopmentFormModel[] } =
    useQuery('list-development-forms')
  const t = useTranslations()
  const groupLabels = t.app.discoveryPage.filterDrawer
  const phaseLabels = t.app.common.initiativePhases

  return useMemo(() => {
    const chips: ActiveFilterChip[] = []

    const removeFromArray = (
      key: 'phase' | 'developmentForm',
      value: number,
    ) => {
      const next = (filters[key] ?? []).filter((v: number) => v !== value)
      setFilters({ ...filters, [key]: next.length ? next : undefined })
    }

    for (const id of filters.phase ?? []) {
      const phase = phases?.find((p) => p.id === id)
      if (!phase) continue
      chips.push({
        key: `phase:${id}`,
        label: `${groupLabels.phase}: ${phaseLabels[phase.phaseType]}`,
        onRemove: () => removeFromArray('phase', id),
      })
    }

    for (const id of filters.developmentForm ?? []) {
      const form = developmentForms?.find((f) => f.id === id)
      if (!form) continue
      chips.push({
        key: `developmentForm:${id}`,
        label: `${groupLabels.developmentForm}: ${form.name}`,
        onRemove: () => removeFromArray('developmentForm', id),
      })
    }

    if (
      filters.searchingForMembers !== null &&
      filters.searchingForMembers !== undefined
    ) {
      chips.push({
        key: 'searchingForMembers',
        label: `${groupLabels.lookingForMembers}: ${
          filters.searchingForMembers ? groupLabels.yes : groupLabels.no
        }`,
        onRemove: () =>
          setFilters({ ...filters, searchingForMembers: undefined }),
      })
    }

    return chips
  }, [filters, setFilters, phases, developmentForms, groupLabels, phaseLabels])
}
